import React from "react";
const FilterLabels = ({ LabelText, closeBtn, FilterAction, }) => {
    return (React.createElement("div", { className: "ed-filter-label-wrapper" }, closeBtn ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tag-container" },
            React.createElement("div", { className: "ed-filter-label-text" }, LabelText),
            React.createElement("span", { className: "edel-icon-close", onClick: () => FilterAction(LabelText) })))) : (React.createElement("div", { className: "tag-container clear-all-fix" },
        React.createElement("div", { className: "ed-filter-label-text", onClick: () => FilterAction(LabelText) }, LabelText)))));
};
export default FilterLabels;
